import { compose } from '@bem-react/core';

import {
    Textarea as TextareaPresenter,
    withSizeM,
    withThemeNormal
} from '@yandex-lego/components/Textarea/desktop';

const Textarea = compose(
    withSizeM,
    withThemeNormal
)(TextareaPresenter);

export default Textarea;
